module.exports = "<drag-scroll #scroll>\r\n  <div class=\"services-container\">\r\n    <app-service *ngFor=\"let service of servicesCopy\"\r\n      [systemId]=\"service.systemId\"\r\n      [subSystemId]=\"service.subSystemId\" \r\n      [value]=\"service.value\"\r\n      [status]=\"service.status\">\r\n    </app-service>\r\n  </div>\r\n</drag-scroll>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/table-column/services-row/services-row.component.html
// module id = ./src/app/components/table-column/services-row/services-row.component.html
// module chunks = main